// Module
var code = `<button
  type="button"
  class="deck-control deck-control--fullscreen"
  data-event-type="fullscreen"
  aria-pressed="false"
  aria-label="Enter full screen"
>
  <svg class="deck-control-icon deck-control-icon--expand" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" />
  </svg>
  <svg class="deck-control-icon deck-control-icon--collapse" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d="M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5" />
  </svg>
</button>

<!-- PDF download: hidden until the PDF is formatted and the action is wired.
     Restore by uncommenting; the styles and the chrome check still cover it.
<button
  type="button"
  class="deck-control deck-control--pdf"
  data-event-type="pdf"
  aria-label="Download PDF"
>
  <svg class="deck-control-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d="M12 4v11M7 10l5 5 5-5M5 20h14" />
  </svg>
</button>
-->
`;
// Exports
module.exports = code;